module.exports = __webpack_public_path__ + "img/president_message_ja.91de04c.webp";